// extracted by mini-css-extract-plugin
export var addButton = "_nu-0";
export var border = "_nu-8";
export var check = "_nu-h";
export var danger = "_nu-6";
export var dropdownContainer = "_nu-1";
export var editModalBody = "_nu-j";
export var footerContainer = "_nu-i";
export var fullWidth = "_nu-a";
export var hide = "_nu-9";
export var icon = "_nu-3";
export var input = "_nu-7";
export var inputFlex = "_nu-b";
export var inputWrapper = "_nu-c";
export var manualFocus = "_nu-5";
export var optionButton = "_nu-4";
export var pillWrapper = "_nu-e";
export var pointer = "_nu-2";
export var showOverflow = "_nu-f";
export var tagsFlex = "_nu-d";
export var xButton = "_nu-g";